import { h } from 'preact'
import { Button } from '../../components/button'
import * as style from './style.css'

interface Props {
    backStep?: number
    nextStep?: number
    isNextDisabled?: boolean
    nextLabel?: string | JSX.Element
    onNext?: () => void
    onBack?: () => void
}

const StepFooter: preact.FunctionalComponent<Props> = ({
    backStep,
    nextStep,
    isNextDisabled,
    nextLabel = 'Next ›',
    onNext,
    onBack,
}) => {
    return (
        <section class={style.stepFooter}>
            {backStep !== undefined && <Button onClick={onBack}>Back</Button>}
            {(nextStep !== undefined || onNext !== undefined) && (
                <Button primary={true} disabled={isNextDisabled} onClick={onNext}>
                    {nextLabel}
                </Button>
            )}
        </section>
    )
}

export default StepFooter
